<template>
    <div class="page-login"  v-loading="isShowLoading">
        <div class="bg"></div>
        <div class="main">
            <div style="flex: 0 0 80px; background-color: #fff;">
                <div style="max-width: 960px; margin: auto; line-height: 80px;">
                    <span style="font-size: 22px">国家乡村振兴税收优惠政策数据上传系统</span>
                </div>
            </div>
            <div style="flex: 1;">
                <div style="max-width: 800px; margin: auto; display: flex; margin-top: 80px">
                    <div style="flex: 1;">
                        <img width="100%" src="../../assets/img/home.png" />
                    </div>
                    <div style="flex: 1; text-align: center;">
                        <div style="margin: auto; width: 360px; height: 400px; border-radius: 8px; border: 1px solid #fff; background-color: #fff; box-shadow: 0 0 20px 0 rgba(14, 40, 93, .08); position: relative;">
                            <!-- background: url('/yncz/assets/img/ewm.png'); -->
                            <div style="position: absolute; top: 8px; right: 8px; height: 48px; width: 48px; "></div>

                            <div style="position: absolute; top: 8px; right: 8px; border-style: solid; border-width: 24px 24px 24px 24px; border-color: transparent transparent #fff #fff; width: 0px; height: 0px; cursor: pointer;"></div>

                            <div style="margin: auto; padding: 25px;">
                                <div style="margin: 40px;">账号登录</div>
                                <el-form ref="form" :model="form" label-width="80px">
                                    <el-form-item label="用户名">
                                        <el-input v-model="form.czryDm"></el-input>
                                    </el-form-item>
                                    <el-form-item label="密码">
                                        <el-input v-model="form.password" show-password></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" @click="onSubmit">登录</el-button>
                                        <el-button type="primary" @click="onReset">重置</el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <div>
                    <p>
                        <span>版权所有：北京东港瑞宏科技有限公司</span>
                    </p>
                    <p>建议您使用Eage、Chrome、360等主流浏览器访问本系统</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                form: {
                    czryDm: "",
                    password: "",
                    user: "super"
                },
                isShowLoading: false
            };
        },
        methods: {
            onSubmit() {
                this.isShowLoading = true;
                sessionStorage.clear();
                console.log("submit!");
                // let token;
                // if (this.form.user == "yn1") {
                //   token =
                //     "1082D948EB31831133175E0AB9A92A7A7F7E3502F97EDAEDB0F894EB298C97052F9C0F83A57ECDA8F384D3A56CDEDDC210D8243831D430BF88E169955BEBE6AF";
                // } else if (this.form.user == "super") {
                //   token =
                //     "1082D948EB318311B80190E65383795537AAD400443A498666027843587440CEE11238F9A3B14E786714AE8BFFE020E300DC2BBD3F19493587AF188D06BBFFBB425D3EED90667A08A6731DC284A57D266087A64885B4BB83";
                // }

                // sessionStorage.setItem("token", token);
                // //this.$router.push("/console");
                // this.$router.push("/index");

                this.$axios
                    .post("/api?jkDm=LOGINBYPASSWORD", this.form)
                    .then(response => {
                        this.isShowLoading = false;
                        let data = response.data;
                        console.log(data.returnCode, data);
                        if (data.returnCode == "0000") {
                            sessionStorage.setItem("token", data.token);
                            window["userName"] = data.userName;
                            this.$router.push("/index");
                        } else {
                            this.$message.error(data.returnMsg);
                        }
                    });
            },
			onReset() {
				this.form.czryDm = "";
				this.form.password = "";
			}
        }
    };
</script>
<style scoped>
    .el-container {
        height: 100%;
    }

    .el-header,
    .el-footer {
        background-color: #b3c0d1;
        color: #333;
        text-align: center;
        line-height: 60px;
    }

    .el-main {
        background-color: #e9eef3;
        color: #333;
        text-align: center;
        height: calc(100% - 120px);
    }

    .login-panel {
        margin: auto;
        width: 320px;
    }

    .page-login {
        height: 100%;
        background-color: #f5f8fd;
    }

    .page-login .bg {
        height: 100%;
        width: 100%;
        position: absolute;
        z-index: 10;
        background: url("../../assets/img/login-bg.png") no-repeat;
        background-size: cover;
    }

    .page-login .main {
        height: 100%;
        width: 100%;
        position: relative;
        z-index: 10;
        display: flex;
        flex-direction: column;
    }

    .page-login .footer {
        flex: 0 0 80px;
        font-size: 14px;
        color: #fff;
    }

    .page-login .footer>div {
        max-width: 960px;
        margin: auto;
        border-top: 1px solid #fff;
        /*color: #999;*/
        line-height: 24px;
    }

    /*page-home*/
    .page-home {
        background-color: #f5f8fd;
    }

    .page-home .main {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .page-home .main * {
        box-sizing: border-box;
    }

    .page-home .layout-top {
        flex: 0 0 40px;
        background-color: #fcfcfc;
        color: #666;
        display: flex;
        line-height: 40px;
        /* rgba(0,21,41,.35) */
        border-bottom: 1px solid #ccc;
        transition: all 0.1s;
    }
</style>
